import React, { Component, useState } from "react";
import "./style.scss";
import classNames from "classnames";
import IconLink from "../../elements/icon-link";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { connect } from "react-redux";
import { selectCookieBannerState, selectAnimationIsOverState } from "../../selectors/application";
import Image from "../../elements/image";
import Heading from "../../elements/heading";
import Toast from "../../elements/toast";
import CookiesAcceptButton from "../../elements/cookies-accept-button";
import cookie from "react-cookies";
import webcookie from "../../utils/webcookie";
import CookieSettings from "../../sections/cookie-settings";
import { changeCookies, toggleCookies, changeAnimation } from "../../redux/actions/cookies";
import { apiAsia } from "../../utils/api-asia";
import Loading from "../../elements/loading";
import { gtag } from "../../utils";
import { S_PRIVACY_ID, S_COOKIE_VERSION, S_LANG, webStorage } from "../../utils/webStorage";

class Cookies extends Component {
  constructor(props, context) {
    super(props, context);
    const { changeCookies } = this.props;
    this.closeCookie = this.closeCookie.bind(this);
    this.notAcceptCookie = this.notAcceptCookie.bind(this);
    const OptanonConsent = cookie.load("OptanonConsent");
    if (!OptanonConsent || OptanonConsent === "null") {
      // changeCookies(true);
    }
    this.state = {
      showCookieModal: false,
      loadingShow: false,
      toastTip: "",
      toastShow: false
    };
		// 8.14新增埋点
		gtag('event', 'L_Private_policy_exp', {
			'page_title': this?.props?.page?.name
		});
  }

  componentWillUnmount() {
    const { changeCookies } = this.props;
    let bool = cookie.load("OptanonConsent") === "null";
    changeCookies(bool);
  }

  componentDidMount() {
    const { changeCookies } = this.props;
    // let OptanonConsent = cookie.load("OptanonConsent");
    // if (OptanonConsent && OptanonConsent.indexOf('Analytics')>0) {
    //   var googlescript = document.getElementById('googlescript');
    //   if (!googlescript) {
    //     webcookie.addSomeScriptDynamically(this.props.lang);
    //   }
    // }
    webcookie.initCookies("OptanonConsent", "null");
    const { Version,PrivacyPolicy } = this.props.fields;
    const lang = webStorage.get(S_LANG) ? webStorage.get(S_LANG) : 'en';
    const code = webcookie.getCookie("newCode"+lang);
    const params = {
      version: Version.value,
      code: code || null,
      language: lang
    };
    apiAsia.consent.check(params).then(res => {
      if (!res[1]) {
        webcookie.setCookie("OptanonConsent", "Functional&Analytics&Marketing"); //accept all cookie settings
      }else{
        changeCookies(true);
      }
    })
    webStorage.set(S_PRIVACY_ID,PrivacyPolicy.id);
    webStorage.set(S_COOKIE_VERSION,Version.value);
    webcookie.initCookies("LK-Web-C-T0", "TRUE");
    webcookie.initCookies("LK-Web-C-T1", "FALSE");
    webcookie.initCookies("LK-Web-C-T2", "FALSE");
    this.removeCookies();
  }

  notAcceptCookie() {
    this.closeCookie();
    // this.setState({
    //   showCookieModal: true
    // });
  }

  closeCookie(e) {
    const { changeCookies } = this.props;
    changeCookies(false);
    // this.setState({
    //   display: false
    // });
  }

  removeCookieList(cookieType) {
    let MarketingCookies = []; //wait for providing
    let analyticsCookies = ["_ga", "_gat", "_gid", "_gac"];
    let result = [];
    if (cookieType === "Marketing") {
      MarketingCookies.map((item, index) => {
        result.push({ name: item, path: `/` });
        return null;
      });
    }
    if (cookieType === "Analytics") {
      analyticsCookies.map((item, index) => {
        result.push({ name: item, path: `/` });
        return null;
      });
    }
    return result;
  }

  removeCookies() {
    let OptanonConsent = cookie.load("OptanonConsent");
    if (!OptanonConsent) {
      return;
    }
    if (OptanonConsent.indexOf("Marketing") < 0) {
      let cookieItems = this.removeCookieList("Marketing");
      cookieItems.map((item, index) => {
        cookie.remove(item.name, { path: item.path });
        return null;
      });
    }
    if (OptanonConsent.indexOf("Analytics") < 0) {
      let cookieItems = this.removeCookieList("Analytics");
      cookieItems.map((item, index) => {
        cookie.remove(item.name, { path: item.path });
        return null;
      });
    }
  }

  saveCookieSetting(settings) {
    gtag('event', 'Component_info', {
      'component_name': 'Cookies',
      'page_title': this?.props?.page?.name
    });
    let checkedItem = "";
    settings.map(item => {
      if (item.checkbox.checked) {
        checkedItem += item.checkbox.id + "&";
      }
    });
    let cookie_Marketing = checkedItem.indexOf("Marketing") > 0 ? "TRUE" : "FALSE";
    let cookie_Analytics = checkedItem.indexOf("Analytics") > 0 ? "TRUE" : "FALSE";
    webcookie.setCookie("OptanonConsent", checkedItem);
    webcookie.setCookie("LK-Web-C-T0", "TRUE"); //Functional
    webcookie.setCookie("LK-Web-C-T1", cookie_Marketing); //Marketing
    webcookie.setCookie("LK-Web-C-T2", cookie_Analytics); //Analytics
    this.setState({
      showCookieModal: false
    });
    this.closeCookie();
  }
  addCookie(objName, objValue) {
    var str = objName + "=" + escape(objValue);
    const expires = new Date();
    expires.setDate(expires.getDate() + 365);
    str += "; expires=" +expires+";Path=/"
    document.cookie = str;
}
  setAllCookie() {
		console.log(this?.props?.page?.name)
    gtag('event', 'Component_info', {
      'component_name': 'Cookies',
      'page_title': this?.props?.page?.name
    });
		// 8.14新增埋点
		let first_click_logged =  localStorage.getItem('first_click_logged');
		if(!first_click_logged) {
			localStorage.setItem('first_click_logged', (new Date()).getTime())
			gtag('event', 'L_first_click', {
				'first_click_time': (new Date()).getTime(),
				'first_click_component': 'Cookies'
			});
		}
		gtag('event', 'L_Private_policy_clk', {
			'page_title': this?.props?.page?.name
		});
    const { Version, PrivacyPolicy } = this.props.fields;
    const { lang } = this.props;
    const that = this;
    const params = {
      version: Version.value,
      PrivacyId: PrivacyPolicy.id,
      language: lang
    };
    apiAsia.consent.submit(params).then(res => {
      if (!!res[0]) {
        this.addCookie("newCode"+lang, res[0],lang) 
       // webcookie.setCookie("code"+lang, res[0]);
        this.closeCookie();
      }else{
        this.closeCookie();
      }
      webcookie.setCookie("OptanonConsent", "Functional&Analytics&Marketing"); //accept all cookie settings
    })
    .catch(err => {
      this.closeCookie();
    });
    // webcookie.addSomeScriptDynamically();
    webcookie.setCookie("LK-Web-C-T0", "TRUE");
    webcookie.setCookie("LK-Web-C-T1", "TRUE");
    webcookie.setCookie("LK-Web-C-T2", "TRUE");
  }

  render() {
    let { props } = this;
    if (!props.fields) return null;
    // console.log(this.props)
    const { showCookieBanner, animationIsOver, changeAnimation } = this.props;
    setTimeout((e) => {
      changeAnimation(true)
    }, 4000)
    const model = props.fields ? props.fields : {};
    const cookiesClasses = classNames(`cookies ${model.colorScheme ? model.colorScheme.fields?.phrase.value : ""}`),
      mediaClasses = "media",
      titleClasses = classNames("title", {
        extended: model.extended.value
      }),
      descriptionClasses = classNames("description", {
        extended: model.extended.value
      }),
      acceptClasses = classNames("accept", {
        extended: model.extended.value
      }),
      rejectClasses = classNames("reject", {
        extended: model.extended.value
      }),
      acceptPrimaryButton = {
        buttonText: model.acceptText && model.acceptText.value,
        colorScheme: model.acceptColorScheme,
        iconName: model.acceptIconName,
        width: "wide",
        callback: this.setAllCookie.bind(this)
      },
      rejectIconLink = {
        iconName: model.rejectIconName,
        colorScheme: model.rejectColorScheme,
        isDisabled: { value: false },
        link: { value: { text: model.rejectText.value } },
        callback: this.notAcceptCookie
      };
    const cookieSettings = {
      heading: {
        html: model.headingBody,
        type: model.headingType ? model.headingType : { fields: { phrase: { value: "h1" } } },
        typographyClass: "type-h1"
      },
      body: {
        html: model.body.value
      },
      acceptAllButton: {
        buttonText: model.acceptbuttonText.value,
        colorScheme: model.acceptbuttonColorScheme,
        iconName: model.acceptbuttonIcon,
        callback: value => {
          // this.saveCookieSetting(value);
        }
      },
      sections: [
        {
          heading: {
            html: model.hideTitle.value ? { value: "" } : model.technicalheadingText,
            type: model.technicalheadingType ? model.technicalheadingType : { fields: { phrase: { value: "h3" } } },
            typographyClass: model.technicalheadingTypographyClass ? model.technicalheadingTypographyClass.value : "type-h3"
          },
          body: {
            html: model.technicalbody.value
          },
          checkbox: {
            id: "Functional",
            label: model.technicalCheckboxLabel.value,
            checked: model.technicalChecked.value,
            disabled: model.technicalDisabled.value,
            error: model.technicalShowError.value,
            onChange: () => console.log("Technical callback")
          }
        },
        {
          heading: {
            html: model.hideTitle.value ? { value: "" } : model.analyticsheadingText,
            type: model.analyticsheadingType ? model.analyticsheadingType : { fields: { phrase: { value: "h3" } } },
            typographyClass: model.analyticsheadingTypographyClass ? model.analyticsheadingTypographyClass.value : "type-h3"
          },
          body: {
            html: model.analyticsbody.value
          },
          checkbox: {
            id: "Analytics",
            label: model.analyticsCheckboxLabel.value,
            checked: model.analyticsChecked.value,
            disabled: model.analyticsDisabled.value,
            error: model.analyticsShowError.value,
            onChange: () => console.log("Analytics callback")
          }
        },
        // {
        //   heading: {
        //     html: model.hideTitle ? {value:""} : model.preferenceheadingText,
        //     type: model.preferenceheadingType ? model.preferenceheadingType : { fields: { phrase: { value: "h3" } } },
        //     typographyClass: model.preferenceheadingTypographyClass ? model.preferenceheadingTypographyClass.value : "type-h3"
        //   },
        //   body: {
        //     html: model.preferencebody.value
        //   },
        //   checkbox: {
        //     id: "Preference",
        //     label: model.preferenceCheckboxLabel.value,
        //     checked: model.preferenceChecked.value,
        //     disabled: model.preferenceDisabled.value,
        //     error: model.preferenceShowError.value,
        //     onChange: () => console.log("Preference callback")
        //   }
        // },
        {
          heading: {
            html: model.hideTitle.value ? { value: "" } : model.marketingheadingText,
            type: model.marketingheadingType ? model.marketingheadingType : { fields: { phrase: { value: "h1" } } },
            typographyClass: model.marketingheadingTypographyClass ? model.marketingheadingTypographyClass.value : "type-h3"
          },
          body: {
            html: model.marketingbody.value
          },
          checkbox: {
            id: "Marketing",
            label: model.marketingCheckboxLabel.value,
            checked: model.marketingChecked.value,
            disabled: model.marketingDisabled.value,
            error: model.marketingShowError.value,
            onChange: () => console.log("Marketing callback")
          }
        }
      ]
    };
    if (showCookieBanner && (animationIsOver || model?.animationIsOver?.value)) {
      return (
        <div>
          <div className={cookiesClasses} datasourceid={props.rendering.dataSource}>
            {model.extended.value && model.media.value && model.media.value.src && <div className={mediaClasses}>{model.media.value && model.media.value.src && <Image {...model.media.value} />}</div>}
            <RichText tag="div" field={model.description} className={descriptionClasses} />
            <div className="btn-content">
              <div className={acceptClasses}>
                <div>
                  <CookiesAcceptButton {...acceptPrimaryButton} />
                </div>
              </div>
              <div className={rejectClasses}>
                <div>
                  <IconLink {...rejectIconLink} />
                </div>
              </div>
            </div>
            { this.state.toastShow && 
               <Toast tip={this.state.toastTip} />
            }
          </div>
          <CookieSettings
            {...{
              ...cookieSettings,
              saveButton: {
                buttonText: model.savebuttonText.value,
                iconName: model.savebuttonIcon,
                colorScheme: model.savebuttonColorScheme,
                callback: value => {
                  this.saveCookieSetting(value);
                }
              },
              showCookieModal: this.state.showCookieModal
            }}
          />
        </div>
      );
    } else return null;
  }
}

const mapStateToProps = state => ({
  showCookieBanner: selectCookieBannerState(state),
  animationIsOver: selectAnimationIsOverState(state)
});
 
const mapDispatchToProps = {
  changeCookies: changeCookies,
  toggleCookies: toggleCookies,
  changeAnimation: changeAnimation
};
export default connect(mapStateToProps, mapDispatchToProps)(Cookies);
